
// import React, { useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import Logo from '../../assets/Logo.svg';
// import mockup from '../../assets/mockup.svg';
// import mockup2 from '../../assets/mockup2.svg';
// import google from '../../assets/google.svg';
// import app from '../../assets/app.svg';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
// import markerIcon from 'leaflet/dist/images/marker-icon.png';
// import markerShadow from 'leaflet/dist/images/marker-shadow.png';
// import Swal from 'sweetalert2';
// import { useNavigate } from 'react-router-dom';

// import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
// import { Link } from 'react-router-dom';
// import { getDashboard, getShipment, getVehicleFleetForDriver, getLiveShipment, markCompleteShipment } from '../../ApiController/ApiService';

// // Configure Leaflet marker icons
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: markerIcon2x,
//   iconUrl: markerIcon,
//   shadowUrl: markerShadow,
// });

// const Dashboard = () => {
//   const { t, i18n } = useTranslation(); // Use i18n directly
//   const [showModal2, setShowModal2] = useState(false);
//   const [error, setError] = useState(null);
//   const [dashboardData, setDashboardData] = useState({
//     totalInTransit: 0,
//     totalContainer: 0,
//     totalDispatched: 0,
//     totalPendingDelivery: 0,
//   });
//   const [isLoading, setIsLoading] = useState(true);
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [shipments3, setShipments3] = useState([]);
//   const [selectedShipment, setSelectedShipment] = useState(null);
//   const [loadingShipment, setLoadingShipment] = useState(false);
//   const navigate = useNavigate();
//   useEffect(() => {
//     const fetchShipments = async () => {
//       try {
//         const token = localStorage.getItem('accessToken');
//         const data = await getLiveShipment(token);
//         setShipments3(data.docs || []);
//       } catch (err) {
//         setError(t('errors.fetchShipmentsFailed'));
//       }
//     };
//     fetchShipments();
//   }, [t]);

//   useEffect(() => {
//     const cached = sessionStorage.getItem("dashboardData");
//     if (cached) {
//       setDashboardData(JSON.parse(cached));
//       setIsLoading(false);
//       return;
//     }
//     const fetchDashboardData = async () => {
//       try {
//         const data = await getDashboard();

//         console.log('data', data)
//         sessionStorage.setItem("dashboardData", JSON.stringify(data));
//         setDashboardData(data);
//         setIsLoading(false);
//       } catch (err) {
//         setError(err.message || t('errors.fetchDashboardFailed'));
//         setIsLoading(false);
//       }
//     };
//     fetchDashboardData();
//   }, [t]);

//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         setLoading(true);
//         const data = await getVehicleFleetForDriver(currentPage);
//         const mappedUsers = data.docs.map(doc => ({
//           name: doc.fullName,
//           userType: doc.userType,
//           currentTrip: doc.shipmentId ? doc.shipmentId.orderId : t('fleet.noTrip'),
//           status: doc.shipmentId
//             ? doc.shipmentId.status === 'approved'
//               ? t('fleet.inTransit')
//               : doc.shipmentId.podDate
//                 ? t('fleet.delivered')
//                 : t('fleet.pending')
//             : t('fleet.free'),
//           statusColor: doc.shipmentId
//             ? doc.shipmentId.status === 'approved'
//               ? 'bg-yellow-400'
//               : doc.shipmentId.podDate
//                 ? 'bg-emerald-500'
//                 : 'bg-blue-500'
//             : 'bg-red-500',
//           nextAssignment: t('fleet.noAssignment'),
//         }));
//         setUsers(mappedUsers);
//         setTotalPages(data.totalPages || 1);
//         setLoading(false);
//       } catch (err) {
//         console.error(`Error fetching users for page ${currentPage}:`, err);
//         setError(t('errors.fetchUsersFailed'));
//         setLoading(false);
//       }
//     };
//     fetchUsers();
//   }, [currentPage, t]);

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages && !loading) {
//       setCurrentPage(page);
//     }
//   };

//   const fetchShipmentDetails = async (id) => {
//     try {
//       setLoadingShipment(true);
//       setError(null);
//       const data = await getShipment(id);
//       setSelectedShipment(data);
//     } catch (err) {
//       console.error('Failed to fetch shipment details:', err);
//       setError(t('errors.fetchShipmentDetailsFailed'));
//     } finally {
//       setLoadingShipment(false);
//     }
//   };

//   const handleViewClick = async (shipmentId) => {
//     await fetchShipmentDetails(shipmentId);
//     setShowModal2(true);
//   };

//   const handleMessageClick = (driverId) => {
//     navigate(`/dashboard/messages`);
//   };

//   const handleMarkAsDelivered = async (shipmentId) => {
//     try {
//       await markCompleteShipment(shipmentId);
//       Swal.fire({
//         icon: 'success',
//         title: t('dashboard.success'),
//         text: t('dashboard.shipmentDelivered'),
//       });
//       setShowModal2(false);
//       // Refresh shipments list
//       const token = localStorage.getItem('accessToken');
//       const data = await getLiveShipment(token);
//       setShipments3(data.docs || []);
//     } catch (error) {
//       console.error('Error marking shipment as delivered:', error);
//       Swal.fire({
//         icon: 'error',
//         title: t('dashboard.error'),
//         text: error.message || t('dashboard.markAsDeliveredFailed'),
//       });
//     }
//   };


//   // console.log('users',users)
//   const cards = [
//     {
//       title: t('dashboard.inTransitContainers'),
//       value: dashboardData.totalInTransit,
//       icon: "🛣️",
//       action: t('dashboard.trackNow'),
//       link: "/dashboard/order-container",
//       bgColor: "bg-[#8280FF]",
//     },
//     {
//       title: t('dashboard.totalContainers'),
//       value: dashboardData.totalContainer,
//       icon: "📦",
//       action: t('dashboard.viewAll'),
//       link: "/dashboard/order-container",
//       bgColor: "bg-[#FEC53D]",
//     },
//     {
//       title: t('dashboard.todaysDispatches'),
//       value: dashboardData.totalDispatched,
//       icon: "📅",
//       action: t('dashboard.viewTrips'),
//       link: "/dashboard/dispatch",
//       bgColor: "bg-[#4AD991]",
//     },
//     {
//       title: t('dashboard.pendingDeliveries'),
//       value: dashboardData.totalPendingDelivery,
//       icon: "⏳",
//       action: t('dashboard.dispatch'),
//       link: "/dashboard/dispatch",
//       bgColor: "bg-[#FF9066]",
//     },
//   ];

//   const reports = [
//     {
//       title: t('reports.dailyDispatch'),
//       link: "/dashboard/reports",
//       icon: "📊",
//     },
//     {
//       title: t('reports.monthlyContainer'),
//       link: "/dashboard/reports",
//       icon: "📑",
//     },
//     {
//       title: t('reports.routeOptimization'),
//       link: "/dashboard/reports",
//       icon: "📍",
//     },
//     {
//       title: t('reports.paymentSummary'),
//       link: "/dashboard/invoice",
//       icon: "📆",
//     },
//   ];

//   return (
//     <div className="text-white px-1">
//       <h2 className="text-2xl font-semibold mb-5">{t('dashboard.title')}</h2>
//       <div className="flex flex-col lg:flex-row gap-4">
//         {isLoading ? (
//           <div className="text-white text-center">{t('dashboard.loading')}</div>
//         ) : (
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 flex-1">
//             {cards.map((card, idx) => (
//               <Link to={card.link} key={idx}>
//                 <div
//                   className="rounded-xl p-4 w-full min-w-[200px] flex flex-col justify-between cursor-pointer transition-transform hover:scale-105"
//                   style={{
//                     background: 'linear-gradient(167.8deg, #4100B4 0.5%, #1C004E 99.5%)',
//                   }}
//                 >
//                   <div className="flex justify-between items-start">
//                     <div>
//                       <h4 className="text-[16px] font-inter font-semibold text-white/80">{card.title}</h4>
//                       <p className="text-[40px] font-bold">{card.value}</p>
//                     </div>
//                     <div className={`p-2 rounded-2xl text-[20px] text-center w-[50px] ${card.bgColor}`}>
//                       {card.icon}
//                     </div>
//                   </div>
//                   <div className="text-[16px] text-[#00B69B] font-medium cursor-pointer hover:underline">
//                     {card.action}
//                   </div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         )}
//         <div
//           className="rounded-xl w-full lg:max-w-[420px] relative"
//           style={{
//             background: 'linear-gradient(167.8deg, #4100B4 0.5%, #1C004E 99.5%)',
//           }}
//         >
//           <div className="absolute top-4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
//             <img src={Logo} alt={t('alt.companyLogo')} className="w-24 h-auto" />
//           </div>
//           <div className="flex flex-row pt-10 items-center gap-2 justify-center">
//             <h3 className="bg-white text-[16px] rounded-r-xl ps-2 font-bold text-black">
//               {t('dashboard.stayConnected')}
//             </h3>
//             <p>&</p>
//             <p className="text-sm flex items-center gap-2">
//               <span className="bg-white text-black px-2 py-1 rounded font-semibold text-[16px]">
//                 🛠️ {t('dashboard.roadsideHelp')}
//               </span>
//             </p>
//           </div>
//           <div className="flex flex-row items-center justify-between">
//             <div className="relative mt-4 flex justify-center lg:justify-start">
//               <img
//                 src={mockup}
//                 alt={t('alt.appPreview1')}
//                 className="w-28 max-h-40 h-auto relative z-10"
//               />
//               <img
//                 src={mockup2}
//                 alt={t('alt.appPreview2')}
//                 className="w-36 max-h-48 h-auto absolute -bottom-4 left-16 z-20"
//               />
//             </div>
//             <div className="flex-1 ml-20">
//               <ul className="text-[12px] mt-6 list-disc list-inside text-white space-y-1">
//                 <li>{t('dashboard.realTimeUpdates')}</li>
//                 <li>{t('dashboard.proofOfDelivery')}</li>
//                 <li>{t('dashboard.chatWithDispatchers')}</li>
//                 <li>{t('dashboard.documentManagement')}</li>
//               </ul>
//               <div className="mt-4">
//                 <p className="text-xs text-white/70 mb-1">{t('dashboard.downloadApp')}</p>
//                 <div className="flex mt-2 gap-2">
//                   <img src={google} alt={t('alt.googlePlay')} className="w-12 lg:w-24" />
//                   <img src={app} alt={t('alt.appStore')} className="w-12 lg:w-24" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* <div className="text-white">
//         <h2 className="text-[24px] font-semibold mb-4 mt-4">{t('dashboard.liveContainer')}</h2>
//         <div className="flex flex-wrap gap-9">
//           {shipments3.map((shipment, index) => (
//             <div key={shipment._id || index} className="bg-white text-black rounded-xl w-80">
//               <div className="flex justify-between items-center bg-[#1E1B2E] font-inter text-white text-[14px] px-4 py-2 rounded-t-lg">
//                 <span>{t('dashboard.shipmentId', { id: shipment.Id })}</span>
//                 <span className="flex items-center gap-1">
//                   <span className="w-2 h-2 bg-green-500 rounded-full"></span>
//                   {t(`dashboard.status.${shipment.status.toLowerCase()}`, { defaultValue: shipment.status })}
//                 </span>
//               </div>
//               <div className="p-2">
//                 <h3 className="font-bold">{shipment.origin} → {shipment.destination}</h3>
//                 <p className="text-sm">{t('dashboard.containerNo', { number: shipment.containerNumber })}</p>
//                 <p className="text-sm mb-2">{t('dashboard.driverName', { name: shipment.driverContactNumber || 'N/A' })}</p>
//                 <MapContainer
//                   center={[
//                     shipment.currentLocation.coordinates[1],
//                     shipment.currentLocation.coordinates[0],
//                   ]}
//                   zoom={5}
//                   scrollWheelZoom={false}
//                   style={{ height: '200px', width: '100%', borderRadius: '0.5rem', marginBottom: '0.75rem' }}
//                 >
//                   <TileLayer
//                     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                     attribution={t('dashboard.mapAttribution')}
//                   />
//                   <Marker position={[shipment.currentLocation.coordinates[1], shipment.currentLocation.coordinates[0]]} />
//                   <Marker position={[shipment.destinationLocation.coordinates[1], shipment.destinationLocation.coordinates[0]]} />
//                   <Polyline
//                     positions={[
//                       [shipment.currentLocation.coordinates[1], shipment.currentLocation.coordinates[0]],
//                       [shipment.destinationLocation.coordinates[1], shipment.destinationLocation.coordinates[0]],
//                     ]}
//                     color="blue"
//                   />
//                 </MapContainer>
//                 <div className="flex justify-center">
//                   <button
//                     onClick={() => handleViewClick(shipment._id)}
//                     className="bg-[#7A3AED] text-white text-sm px-6 py-1 rounded-full"
//                   >
//                     {t('dashboard.view')}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div> */}
//       {showModal2 && (
//         <div style={{ zIndex: '10000' }} className="fixed inset-0 bg-opacity-50 flex items-center justify-center">
//           <div
//             className="rounded-xl shadow-xl text-white p-6 relative w-[90%] max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
//             style={{
//               background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
//             }}
//           >
//             <button
//               onClick={() => setShowModal2(false)}
//               className="absolute top-2 right-4 text-2xl font-bold"
//             >
//               ×
//             </button>
//             {loadingShipment ? (
//               <div className="flex justify-center items-center h-64">
//                 <p>{t('dashboard.loadingShipment')}</p>
//               </div>
//             ) : error ? (
//               <div className="text-red-500 text-center py-4">{t('errors.error', { message: error })}</div>
//             ) : selectedShipment ? (
//               <>
//                 <h2 className="text-xl font-bold mb-4">{t('dashboard.detailedContainerView')}</h2>
//                 <form className="space-y-4">
//                   <h3 className="text-sm text-cyan-400 font-semibold mt-4">
//                     {t('dashboard.shipmentOverview')}
//                   </h3>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.containerId')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={selectedShipment.containerNumber || t('dashboard.na')}
//                       readOnly
//                     />
//                   </div>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.purchaseOrderNo')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={selectedShipment.purchaseOrderNumber || t('dashboard.na')}
//                       readOnly
//                     />
//                   </div>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.customerName')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={selectedShipment.customerName || t('dashboard.na')}
//                       readOnly
//                     />
//                   </div>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.numberOfPallets')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={selectedShipment.palletCount || t('dashboard.na')}
//                       readOnly
//                     />
//                   </div>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.goodsType')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={selectedShipment.goodsType || t('dashboard.na')}
//                       readOnly
//                     />
//                   </div>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.addedOn')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={new Date(selectedShipment.createdAt).toLocaleDateString(i18n.language) || t('dashboard.na')} // Use i18n.language
//                       readOnly
//                     />
//                   </div>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.estimatedDeliveryDate')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={new Date(selectedShipment.estimatedDeliveryDate).toLocaleDateString(i18n.language) || t('dashboard.na')} // Use i18n.language
//                       readOnly
//                     />
//                   </div>
//                   <h3 className="text-sm text-cyan-400 font-semibold mt-4">
//                     {t('dashboard.routeStatusTracking')}
//                   </h3>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.route')}</label>
//                     <div className="relative w-full rounded-lg overflow-hidden shadow-md">
//                       <div className="w-full h-48 bg-gray-200 flex items-center justify-center">
//                         {t('dashboard.mapView', { origin: selectedShipment.origin, destination: selectedShipment.destination })}
//                       </div>
//                       <button className="absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-violet-600 text-white px-6 py-2 rounded-md shadow-lg hover:bg-violet-700 flex items-center gap-2">
//                         <span role="img" aria-label="truck">🚛</span> {t('dashboard.trackContainer')}
//                       </button>
//                     </div>
//                   </div>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.currentStatus')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={t(`dashboard.status.${selectedShipment.status.toLowerCase()}`, { defaultValue: selectedShipment.status }) || t('dashboard.na')}
//                       readOnly
//                     />
//                   </div>
//                   <h3 className="text-sm text-cyan-400 font-semibold mt-4">
//                     {t('dashboard.driverAssignmentControl')}
//                   </h3>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.assignedDriver')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={selectedShipment.driverName || t('dashboard.na')}
//                       readOnly
//                     />
//                   </div>
//                   <div>
//                     <label className="text-sm block mb-1">{t('dashboard.vehicleNumber')}</label>
//                     <input
//                       className="w-full px-3 py-2 rounded bg-white text-black"
//                       value={selectedShipment.vehicleNumber || t('dashboard.na')}
//                       readOnly
//                     />
//                   </div>
//                   {selectedShipment.driverContactNumber && (
//                     <div className="mb-4">
//                       <label className="text-sm block mb-2 text-white">{t('dashboard.driverContact')}</label>
//                       <div className="flex gap-4">
//                         <a
//                           href={`tel:${selectedShipment.driverContactNumber}`}
//                           className="flex items-center gap-2 bg-[#F1EEFF] text-[#8000FF] px-4 py-2 rounded-md font-medium"
//                         >
//                           <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a2 2 0 011.95 1.45l.71 2.55a2 2 0 01-.45 1.9l-1.3 1.3a11.042 11.042 0 005.06 5.06l1.3-1.3a2 2 0 011.9-.45l2.55.71A2 2 0 0121 17.72V21a2 2 0 01-2 2h-1C9.16 23 1 14.84 1 4V3a2 2 0 012-2h0z" />
//                           </svg>
//                           {t('dashboard.call')}
//                         </a>
//                         <a
//                           href={`sms:${selectedShipment.driverContactNumber}`}
//                           className="flex items-center gap-2 bg-[#F1EEFF] text-[#8000FF] px-4 py-2 rounded-md font-medium"
//                         >
//                           <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h6m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
//                           </svg>
//                           {t('dashboard.message')}
//                         </a>
//                       </div>
//                     </div>
//                   )}
//                 </form>
//                 <div className="mt-6 flex gap-4 justify-center">
//                   <button
//                     onClick={() => setShowModal2(false)}
//                     className="flex items-center gap-2 bg-[#6f1aff] text-white py-2 px-4 rounded-md font-semibold"
//                   >
//                     <span className="text-green-400">✅</span> {t('dashboard.markAsDelivered')}
//                   </button>
//                   <button
//                     onClick={() => setShowModal2(false)}
//                     className="bg-[#00B69B] text-white py-2 px-4 rounded-md font-semibold"
//                   >
//                     {t('dashboard.saveUpdate')}
//                   </button>
//                 </div>
//               </>
//             ) : null}
//           </div>
//         </div>
//       )}
//       <div className="bg-[#1D2461] text-white rounded-xl mx-auto mt-8 p-4">
//         <h2 className="text-lg font-semibold mb-4 ps-2 pt-2">{t('dashboard.fleetUserStatus')}</h2>
//         <div className="overflow-x-auto">
//           <div className="grid grid-cols-4 bg-[#707EFF] text-sm text-[#303030] font-medium rounded-md py-2 px-4 min-w-[640px]">
//             <div>{t('dashboard.driver')}</div>
//             <div>{t('dashboard.currentTrip')}</div>
//             <div>{t('dashboard.statusLabel')}</div> {/* Updated to use statusLabel */}
//             <div>{t('dashboard.nextAssignment')}</div>
//           </div>
//           <div className="relative min-h-[100px]">
//             {loading && (
//               <div className="absolute inset-0 flex items-center justify-center">
//                 <div className="w-6 h-6 border-4 border-t-[#707EFF] border-[#2A2A4D] rounded-full animate-spin"></div>
//               </div>
//             )}
//             {/* {error && (
//               <div className="text-red-500 text-center py-4">{t('errors.error', { message: error })}</div>
//             )} */}
//             {/* {!loading && !error && users.length === 0 && (
//               <div className="text-white text-center py-4">{t('dashboard.noUsersFound')}</div>
//             )} */}
//             {users.length > 0 && (
//               <div>
//                 {users.map((user) => (
//                   <div
//                     key={user.id}
//                     className="grid grid-cols-4 items-center py-4 px-4 border-t border-[#2A2A4D] text-sm min-w-[640px]"
//                   >
//                     <div>{user.name}</div>
//                     <div>{user.currentTrip}</div>
//                     <div>
//                       <span
//                         className={`text-xs text-white font-semibold px-3 py-1 rounded-full ${user.statusColor}`}
//                       >
//                         {user.status}
//                       </span>
//                     </div>
//                     <div>{user.nextAssignment}</div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//         {totalPages > 1 && (
//           <div className="flex flex-wrap justify-center items-center mt-4 space-x-2">
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1 || loading}
//               className={`px-3 py-1 rounded-md text-sm sm:text-xs ${currentPage === 1 || loading
//                 ? 'bg-gray-500 cursor-not-allowed'
//                 : 'bg-[#707EFF] hover:bg-[#5a6bff] text-[#303030]'
//                 }`}
//             >
//               {t('dashboard.previous')}
//             </button>
//             {[...Array(totalPages).keys()].map((_, index) => {
//               const page = index + 1;
//               return (
//                 <button
//                   key={page}
//                   onClick={() => handlePageChange(page)}
//                   disabled={loading}
//                   className={`px-3 py-1 rounded-md text-sm sm:text-xs ${currentPage === page
//                     ? 'bg-[#707EFF] text-[#303030]'
//                     : 'bg-[#2A2A4D] hover:bg-[#3a3a5d] text-white'
//                     } ${loading ? 'cursor-not-allowed opacity-50' : ''}`}
//                 >
//                   {page}
//                 </button>
//               );
//             })}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages || loading}
//               className={`px-3 py-1 rounded-md text-sm sm:text-xs ${currentPage === totalPages || loading
//                 ? 'bg-gray-500 cursor-not-allowed'
//                 : 'bg-[#707EFF] hover:bg-[#5a6bff] text-[#303030]'
//                 }`}
//             >
//               {t('dashboard.next')}
//             </button>
//           </div>
//         )}
//       </div>
//       <div className="mt-8 text-white rounded-lg mb-4">
//         <h2 className="text-[24px] font-semibold mb-4">{t('Reports')}</h2>
//         <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
//           {reports.map((report, index) => (
//             <Link
//               to={report.link}
//               key={index}
//               className="bg-[#1D2461] rounded-xl flex flex-col items-center justify-center text-center p-4 hover:shadow-md transition-shadow"
//             >
//               <div className="text-4xl mb-3">{report.icon}</div>
//               <p className="text-[20px] font-normal">{report.title}</p>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../assets/Logo.svg';
import mockup from '../../assets/mockup.svg';
import mockup2 from '../../assets/mockup2.svg';
import google from '../../assets/google.svg';
import app from '../../assets/app.svg';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
import { Link } from 'react-router-dom';
import { getDashboard, getShipment, getVehicleFleetForDriver, getLiveShipment, markCompleteShipment } from '../../ApiController/ApiService';
import { useDashboard } from '../Context/Dashboardcontext';

// Import your custom hook to access the user profile

// Configure Leaflet marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const Dashboard = () => {
  const { t, i18n } = useTranslation();
  const [showModal2, setShowModal2] = useState(false);
  const [error, setError] = useState(null);
  const [dashboardData, setDashboardData] = useState({
    totalInTransit: 0,
    totalContainer: 0,
    totalDispatched: 0,
    totalPendingDelivery: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [shipments3, setShipments3] = useState([]);
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [loadingShipment, setLoadingShipment] = useState(false);
  const navigate = useNavigate();

  // Extract userProfile from the context
  const { userProfile } = useDashboard();

  useEffect(() => {
    const fetchShipments = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const data = await getLiveShipment(token);
        
        const fetchedDocs = data.docs || [];
        
        // --- AI PACKAGE FILTER LOGIC FOR SHIPMENTS ---
        // Check if the user has an AI package. 
        // If they do (aiPackageId exists), show all fetched documents.
        // If they do not, filter the array and only keep documents where the companyType is 'Dispax'.
        const filteredShipments = userProfile?.aiPackageId 
          ? fetchedDocs 
          : fetchedDocs.filter(doc => doc?.companyType === 'Dispax');

        setShipments3(filteredShipments);
      } catch (err) {
        setError(t('errors.fetchShipmentsFailed'));
      }
    };
    fetchShipments();
  }, [t, userProfile?.aiPackageId]); // Re-run if the AI package status changes

  useEffect(() => {
    const cached = sessionStorage.getItem("dashboardData");
    if (cached) {
      setDashboardData(JSON.parse(cached));
      setIsLoading(false);
      return;
    }
    const fetchDashboardData = async () => {
      try {
        const data = await getDashboard();
        console.log('data', data)
        sessionStorage.setItem("dashboardData", JSON.stringify(data));
        setDashboardData(data);
        setIsLoading(false);
      } catch (err) {
        setError(err.message || t('errors.fetchDashboardFailed'));
        setIsLoading(false);
      }
    };
    fetchDashboardData();
  }, [t]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const data = await getVehicleFleetForDriver(currentPage);
        
        const fetchedDocs = data.docs || [];

        // --- AI PACKAGE FILTER LOGIC FOR FLEET USERS ---
        // Apply the same logic here: show all drivers if the user has an AI package,
        // otherwise restrict the view to only drivers assigned to the 'Dispax' company.
        const filteredDocs = userProfile?.aiPackageId 
          ? fetchedDocs 
          : fetchedDocs.filter(doc => doc?.companyType === 'Dispax');

        const mappedUsers = filteredDocs.map(doc => ({
          id: doc._id, // Add a unique ID for the React map key
          name: doc.fullName,
          userType: doc.userType,
          currentTrip: doc.shipmentId ? doc.shipmentId.orderId : t('fleet.noTrip'),
          status: doc.shipmentId
            ? doc.shipmentId.status === 'approved'
              ? t('fleet.inTransit')
              : doc.shipmentId.podDate
                ? t('fleet.delivered')
                : t('fleet.pending')
            : t('fleet.free'),
          statusColor: doc.shipmentId
            ? doc.shipmentId.status === 'approved'
              ? 'bg-yellow-400'
              : doc.shipmentId.podDate
                ? 'bg-emerald-500'
                : 'bg-blue-500'
            : 'bg-red-500',
          nextAssignment: t('fleet.noAssignment'),
        }));
        
        setUsers(mappedUsers);
        setTotalPages(data.totalPages || 1);
        setLoading(false);
      } catch (err) {
        console.error(`Error fetching users for page ${currentPage}:`, err);
        setError(t('errors.fetchUsersFailed'));
        setLoading(false);
      }
    };
    fetchUsers();
  }, [currentPage, t, userProfile?.aiPackageId]); // Re-run if the AI package status changes

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages && !loading) {
      setCurrentPage(page);
    }
  };

  const fetchShipmentDetails = async (id) => {
    try {
      setLoadingShipment(true);
      setError(null);
      const data = await getShipment(id);
      setSelectedShipment(data);
    } catch (err) {
      console.error('Failed to fetch shipment details:', err);
      setError(t('errors.fetchShipmentDetailsFailed'));
    } finally {
      setLoadingShipment(false);
    }
  };

  const handleViewClick = async (shipmentId) => {
    await fetchShipmentDetails(shipmentId);
    setShowModal2(true);
  };

  const handleMessageClick = (driverId) => {
    navigate(`/dashboard/messages`);
  };

  const handleMarkAsDelivered = async (shipmentId) => {
    try {
      await markCompleteShipment(shipmentId);
      Swal.fire({
        icon: 'success',
        title: t('dashboard.success'),
        text: t('dashboard.shipmentDelivered'),
      });
      setShowModal2(false);
      
      // Refresh shipments list
      const token = localStorage.getItem('accessToken');
      const data = await getLiveShipment(token);
      
      // Re-apply filter after marking as delivered
      const filteredShipments = userProfile?.aiPackageId 
          ? data.docs || [] 
          : (data.docs || []).filter(doc => doc?.companyType === 'Dispax');
          
      setShipments3(filteredShipments);
    } catch (error) {
      console.error('Error marking shipment as delivered:', error);
      Swal.fire({
        icon: 'error',
        title: t('dashboard.error'),
        text: error.message || t('dashboard.markAsDeliveredFailed'),
      });
    }
  };

  const cards = [
    {
      title: t('dashboard.inTransitContainers'),
      value: dashboardData.totalInTransit,
      icon: "🛣️",
      action: t('dashboard.trackNow'),
      link: "/dashboard/order-container",
      bgColor: "bg-[#8280FF]",
    },
    {
      title: t('dashboard.totalContainers'),
      value: dashboardData.totalContainer,
      icon: "📦",
      action: t('dashboard.viewAll'),
      link: "/dashboard/order-container",
      bgColor: "bg-[#FEC53D]",
    },
    {
      title: t('dashboard.todaysDispatches'),
      value: dashboardData.totalDispatched,
      icon: "📅",
      action: t('dashboard.viewTrips'),
      link: "/dashboard/dispatch",
      bgColor: "bg-[#4AD991]",
    },
    {
      title: t('dashboard.pendingDeliveries'),
      value: dashboardData.totalPendingDelivery,
      icon: "⏳",
      action: t('dashboard.dispatch'),
      link: "/dashboard/dispatch",
      bgColor: "bg-[#FF9066]",
    },
  ];

  const reports = [
    {
      title: t('reports.dailyDispatch'),
      link: "/dashboard/reports",
      icon: "📊",
    },
    {
      title: t('reports.monthlyContainer'),
      link: "/dashboard/reports",
      icon: "📑",
    },
    {
      title: t('reports.routeOptimization'),
      link: "/dashboard/reports",
      icon: "📍",
    },
    {
      title: t('reports.paymentSummary'),
      link: "/dashboard/invoice",
      icon: "📆",
    },
  ];

  return (
    <div className="text-white px-1">
      <h2 className="text-2xl font-semibold mb-5">{t('dashboard.title')}</h2>
      <div className="flex flex-col lg:flex-row gap-4">
        {isLoading ? (
          <div className="text-white text-center">{t('dashboard.loading')}</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 flex-1">
            {cards.map((card, idx) => (
              <Link to={card.link} key={idx}>
                <div
                  className="rounded-xl p-4 w-full min-w-[200px] flex flex-col justify-between cursor-pointer transition-transform hover:scale-105"
                  style={{
                    background: 'linear-gradient(167.8deg, #4100B4 0.5%, #1C004E 99.5%)',
                  }}
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="text-[16px] font-inter font-semibold text-white/80">{card.title}</h4>
                      <p className="text-[40px] font-bold">{card.value}</p>
                    </div>
                    <div className={`p-2 rounded-2xl text-[20px] text-center w-[50px] ${card.bgColor}`}>
                      {card.icon}
                    </div>
                  </div>
                  <div className="text-[16px] text-[#00B69B] font-medium cursor-pointer hover:underline">
                    {card.action}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
        <div
          className="rounded-xl w-full lg:max-w-[420px] relative"
          style={{
            background: 'linear-gradient(167.8deg, #4100B4 0.5%, #1C004E 99.5%)',
          }}
        >
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <img src={Logo} alt={t('alt.companyLogo')} className="w-24 h-auto" />
          </div>
          <div className="flex flex-row pt-10 items-center gap-2 justify-center">
            <h3 className="bg-white text-[16px] rounded-r-xl ps-2 font-bold text-black">
              {t('dashboard.stayConnected')}
            </h3>
            <p>&</p>
            <p className="text-sm flex items-center gap-2">
              <span className="bg-white text-black px-2 py-1 rounded font-semibold text-[16px]">
                🛠️ {t('dashboard.roadsideHelp')}
              </span>
            </p>
          </div>
          <div className="flex flex-row items-center justify-between">
            <div className="relative mt-4 flex justify-center lg:justify-start">
              <img
                src={mockup}
                alt={t('alt.appPreview1')}
                className="w-28 max-h-40 h-auto relative z-10"
              />
              <img
                src={mockup2}
                alt={t('alt.appPreview2')}
                className="w-36 max-h-48 h-auto absolute -bottom-4 left-16 z-20"
              />
            </div>
            <div className="flex-1 ml-20">
              <ul className="text-[12px] mt-6 list-disc list-inside text-white space-y-1">
                <li>{t('dashboard.realTimeUpdates')}</li>
                <li>{t('dashboard.proofOfDelivery')}</li>
                <li>{t('dashboard.chatWithDispatchers')}</li>
                <li>{t('dashboard.documentManagement')}</li>
              </ul>
              <div className="mt-4">
                <p className="text-xs text-white/70 mb-1">{t('dashboard.downloadApp')}</p>
                <div className="flex mt-2 gap-2">
                  <img src={google} alt={t('alt.googlePlay')} className="w-12 lg:w-24" />
                  <img src={app} alt={t('alt.appStore')} className="w-12 lg:w-24" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {showModal2 && (
        <div style={{ zIndex: '10000' }} className="fixed inset-0 bg-opacity-50 flex items-center justify-center">
          <div
            className="rounded-xl shadow-xl text-white p-6 relative w-[90%] max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
            style={{
              background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
            }}
          >
            <button
              onClick={() => setShowModal2(false)}
              className="absolute top-2 right-4 text-2xl font-bold"
            >
              ×
            </button>
            {loadingShipment ? (
              <div className="flex justify-center items-center h-64">
                <p>{t('dashboard.loadingShipment')}</p>
              </div>
            ) : error ? (
              <div className="text-red-500 text-center py-4">{t('errors.error', { message: error })}</div>
            ) : selectedShipment ? (
              <>
                <h2 className="text-xl font-bold mb-4">{t('dashboard.detailedContainerView')}</h2>
                <form className="space-y-4">
                  <h3 className="text-sm text-cyan-400 font-semibold mt-4">
                    {t('dashboard.shipmentOverview')}
                  </h3>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.containerId')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={selectedShipment.containerNumber || t('dashboard.na')}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.purchaseOrderNo')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={selectedShipment.purchaseOrderNumber || t('dashboard.na')}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.customerName')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={selectedShipment.customerName || t('dashboard.na')}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.numberOfPallets')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={selectedShipment.palletCount || t('dashboard.na')}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.goodsType')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={selectedShipment.goodsType || t('dashboard.na')}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.addedOn')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={new Date(selectedShipment.createdAt).toLocaleDateString(i18n.language) || t('dashboard.na')} 
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.estimatedDeliveryDate')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={new Date(selectedShipment.estimatedDeliveryDate).toLocaleDateString(i18n.language) || t('dashboard.na')} 
                      readOnly
                    />
                  </div>
                  <h3 className="text-sm text-cyan-400 font-semibold mt-4">
                    {t('dashboard.routeStatusTracking')}
                  </h3>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.route')}</label>
                    <div className="relative w-full rounded-lg overflow-hidden shadow-md">
                      <div className="w-full h-48 bg-gray-200 flex items-center justify-center">
                        {t('dashboard.mapView', { origin: selectedShipment.origin, destination: selectedShipment.destination })}
                      </div>
                      <button className="absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-violet-600 text-white px-6 py-2 rounded-md shadow-lg hover:bg-violet-700 flex items-center gap-2">
                        <span role="img" aria-label="truck">🚛</span> {t('dashboard.trackContainer')}
                      </button>
                    </div>
                  </div>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.currentStatus')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={t(`dashboard.status.${selectedShipment.status.toLowerCase()}`, { defaultValue: selectedShipment.status }) || t('dashboard.na')}
                      readOnly
                    />
                  </div>
                  <h3 className="text-sm text-cyan-400 font-semibold mt-4">
                    {t('dashboard.driverAssignmentControl')}
                  </h3>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.assignedDriver')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={selectedShipment.driverName || t('dashboard.na')}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm block mb-1">{t('dashboard.vehicleNumber')}</label>
                    <input
                      className="w-full px-3 py-2 rounded bg-white text-black"
                      value={selectedShipment.vehicleNumber || t('dashboard.na')}
                      readOnly
                    />
                  </div>
                  {selectedShipment.driverContactNumber && (
                    <div className="mb-4">
                      <label className="text-sm block mb-2 text-white">{t('dashboard.driverContact')}</label>
                      <div className="flex gap-4">
                        <a
                          href={`tel:${selectedShipment.driverContactNumber}`}
                          className="flex items-center gap-2 bg-[#F1EEFF] text-[#8000FF] px-4 py-2 rounded-md font-medium"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a2 2 0 011.95 1.45l.71 2.55a2 2 0 01-.45 1.9l-1.3 1.3a11.042 11.042 0 005.06 5.06l1.3-1.3a2 2 0 011.9-.45l2.55.71A2 2 0 0121 17.72V21a2 2 0 01-2 2h-1C9.16 23 1 14.84 1 4V3a2 2 0 012-2h0z" />
                          </svg>
                          {t('dashboard.call')}
                        </a>
                        <a
                          href={`sms:${selectedShipment.driverContactNumber}`}
                          className="flex items-center gap-2 bg-[#F1EEFF] text-[#8000FF] px-4 py-2 rounded-md font-medium"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h6m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                          </svg>
                          {t('dashboard.message')}
                        </a>
                      </div>
                    </div>
                  )}
                </form>
                <div className="mt-6 flex gap-4 justify-center">
                  <button
                    onClick={() => setShowModal2(false)}
                    className="flex items-center gap-2 bg-[#6f1aff] text-white py-2 px-4 rounded-md font-semibold"
                  >
                    <span className="text-green-400">✅</span> {t('dashboard.markAsDelivered')}
                  </button>
                  <button
                    onClick={() => setShowModal2(false)}
                    className="bg-[#00B69B] text-white py-2 px-4 rounded-md font-semibold"
                  >
                    {t('dashboard.saveUpdate')}
                  </button>
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
      <div className="bg-[#1D2461] text-white rounded-xl mx-auto mt-8 p-4">
        <h2 className="text-lg font-semibold mb-4 ps-2 pt-2">{t('dashboard.fleetUserStatus')}</h2>
        <div className="overflow-x-auto">
          <div className="grid grid-cols-4 bg-[#707EFF] text-sm text-[#303030] font-medium rounded-md py-2 px-4 min-w-[640px]">
            <div>{t('dashboard.driver')}</div>
            <div>{t('dashboard.currentTrip')}</div>
            <div>{t('dashboard.statusLabel')}</div> 
            <div>{t('dashboard.nextAssignment')}</div>
          </div>
          <div className="relative min-h-[100px]">
            {loading && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-6 h-6 border-4 border-t-[#707EFF] border-[#2A2A4D] rounded-full animate-spin"></div>
              </div>
            )}
            
            {users.length > 0 && (
              <div>
                {users.map((user) => (
                  <div
                    key={user.id}
                    className="grid grid-cols-4 items-center py-4 px-4 border-t border-[#2A2A4D] text-sm min-w-[640px]"
                  >
                    <div>{user.name}</div>
                    <div>{user.currentTrip}</div>
                    <div>
                      <span
                        className={`text-xs text-white font-semibold px-3 py-1 rounded-full ${user.statusColor}`}
                      >
                        {user.status}
                      </span>
                    </div>
                    <div>{user.nextAssignment}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {totalPages > 1 && (
          <div className="flex flex-wrap justify-center items-center mt-4 space-x-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1 || loading}
              className={`px-3 py-1 rounded-md text-sm sm:text-xs ${currentPage === 1 || loading
                ? 'bg-gray-500 cursor-not-allowed'
                : 'bg-[#707EFF] hover:bg-[#5a6bff] text-[#303030]'
                }`}
            >
              {t('dashboard.previous')}
            </button>
            {[...Array(totalPages).keys()].map((_, index) => {
              const page = index + 1;
              return (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  disabled={loading}
                  className={`px-3 py-1 rounded-md text-sm sm:text-xs ${currentPage === page
                    ? 'bg-[#707EFF] text-[#303030]'
                    : 'bg-[#2A2A4D] hover:bg-[#3a3a5d] text-white'
                    } ${loading ? 'cursor-not-allowed opacity-50' : ''}`}
                >
                  {page}
                </button>
              );
            })}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || loading}
              className={`px-3 py-1 rounded-md text-sm sm:text-xs ${currentPage === totalPages || loading
                ? 'bg-gray-500 cursor-not-allowed'
                : 'bg-[#707EFF] hover:bg-[#5a6bff] text-[#303030]'
                }`}
            >
              {t('dashboard.next')}
            </button>
          </div>
        )}
      </div>
      <div className="mt-8 text-white rounded-lg mb-4">
        <h2 className="text-[24px] font-semibold mb-4">{t('Reports')}</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {reports.map((report, index) => (
            <Link
              to={report.link}
              key={index}
              className="bg-[#1D2461] rounded-xl flex flex-col items-center justify-center text-center p-4 hover:shadow-md transition-shadow"
            >
              <div className="text-4xl mb-3">{report.icon}</div>
              <p className="text-[20px] font-normal">{report.title}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;